import { componentLabel } from '../utils/editor';
import icon from './icons/triangle-exclamation.svg';

/**
 * NV Alert block for GrapesJS.
 *
 * @param editor
 * @param options
 */
export default function (editor, options) {
  editor.BlockManager.add(options.componentType, {
    label: componentLabel(options.componentName, icon),
    category: options.category,
    content: {
      type: options.componentType,
    },
  });
}
